/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCLeftIcon16Regular = forwardRef('ArrowCLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.534 13.027a.75.75 0 0 1-1.06.007L5.63 9.24a1.75 1.75 0 0 1-.008-2.483L9.41 2.97a.75.75 0 0 1 1.06 1.06L6.685 7.82a.25.25 0 0 0 0 .354l3.843 3.793a.75.75 0 0 1 .007 1.06Z" })));
});
